export default {
    key: 'activity',
    common: {
        productName: 'core.productNames.activity',
        splashMessage: 'offerFlow.splashMessage.activity',
        headingAside: 'offerFlow.headingAside.activity',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.activity',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.activity',
        body: 'offerFlow.pages.stepPassengers.body.common',
    },
} satisfies OfferFlowContent;
